// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"1590985a","977":"5d9c67ca"}[chunkId] + ".chunk.js";
};